import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PanelComponent } from './panel.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'

@NgModule({
  declarations: [PanelComponent],
  imports: [CommonModule, FormsModule, TranslateModule, ContentEditableModule],
  exports: [PanelComponent],
})
export class PanelModule {}
